
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Privacy() {
  return (
    <div className="min-h-screen">
      <Header />
      <div className="pt-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="bg-white rounded-xl shadow-lg p-8 lg:p-12">
            <h1 className="text-4xl font-bold text-gray-800 mb-8 text-center" style={{ fontFamily: 'Poppins, sans-serif' }}>
              Política de Privacidade e Termos de Uso
            </h1>
            
            <div className="prose prose-lg max-w-none text-gray-700" style={{ fontFamily: 'Open Sans, sans-serif' }}>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4 mt-8" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Política de Privacidade – PrecNacional
              </h2>
              
              <p className="mb-4">
                A sua privacidade é muito importante para nós. É política do site PrecNacional respeitar a sua privacidade em relação a qualquer informação sua que possamos coletar no site PrecNacional, bem como em outros sites que possuímos e operamos.
              </p>
              
              <p className="mb-4">
                Trabalhamos com base na Lei Geral de Proteção de Dados (Lei nº 13.709/2018), que garante privacidade, confidencialidade, retenção segura de dados e proteção aos direitos fundamentais. Também seguimos as diretrizes da Constituição Federal, do Código de Defesa do Consumidor (Lei nº 8.078/90) e do Marco Civil da Internet (Lei nº 12.965/14).
              </p>
              
              <p className="mb-4">
                Solicitamos informações pessoais somente quando realmente precisamos delas para fornecer nossos serviços. Fazemos isso de maneira justa e legal, com seu conhecimento e consentimento, informando claramente os motivos e como os dados serão utilizados.
              </p>
              
              <p className="mb-4">
                As informações coletadas são retidas apenas pelo tempo necessário para fornecer o serviço solicitado. Quando armazenamos dados, utilizamos medidas de segurança compatíveis com a legislação vigente para evitar perdas, roubos, acessos, divulgações, cópias, usos ou modificações não autorizadas.
              </p>
              
              <p className="mb-4">
                Não compartilhamos suas informações pessoais publicamente ou com terceiros, exceto por determinação judicial.
              </p>
              
              <p className="mb-4">
                Nosso site pode conter links para sites externos que não são operados por nós. Não nos responsabilizamos por práticas de privacidade de terceiros e não temos controle sobre o conteúdo desses sites.
              </p>
              
              <p className="mb-4">
                O uso continuado de nosso site será considerado como aceitação de nossas práticas de privacidade. Em caso de dúvidas sobre como tratamos os dados pessoais, entre em contato pelo e-mail: contato@precnacional.com.br.
              </p>
              
              <p className="mb-6">
                Nossa política é atualizada periodicamente. Mudanças passam a valer a partir de sua publicação no site, sem necessidade de aviso prévio.
              </p>
              
              <h3 className="text-xl font-semibold text-gray-800 mb-4 mt-8" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Política de Cookies
              </h3>
              
              <h4 className="text-lg font-semibold text-gray-800 mb-3 mt-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
                O que são cookies?
              </h4>
              
              <p className="mb-4">
                Cookies são pequenos arquivos armazenados em seu dispositivo para melhorar sua experiência em nosso site. Eles ajudam a lembrar preferências, melhorar funcionalidades e analisar o uso do site.
              </p>
              
              <h4 className="text-lg font-semibold text-gray-800 mb-3 mt-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Como usamos os cookies?
              </h4>
              
              <p className="mb-2">Utilizamos cookies para:</p>
              <ul className="list-disc pl-6 mb-4 space-y-2">
                <li>Pesquisas e questionários, lembrando sua participação e garantindo resultados precisos.</li>
                <li>Formulários, guardando informações para facilitar contatos futuros.</li>
                <li>Preferências do site, garantindo que suas escolhas sejam lembradas em futuras visitas.</li>
                <li>Análise de comportamento de uso, através de ferramentas como Google Analytics.</li>
                <li>Publicidade, oferecendo anúncios relevantes de maneira anônima.</li>
              </ul>
              
              <h4 className="text-lg font-semibold text-gray-800 mb-3 mt-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Desativar cookies
              </h4>
              
              <p className="mb-6">
                Você pode desativar cookies ajustando as configurações do seu navegador. No entanto, isso pode reduzir a funcionalidade de nosso site.
              </p>
              
              <h3 className="text-xl font-semibold text-gray-800 mb-4 mt-8" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Compromisso do Usuário
              </h3>
              
              <p className="mb-2">Ao utilizar o site PrecNacional, o usuário se compromete a:</p>
              <ul className="list-disc pl-6 mb-6 space-y-2">
                <li>Não praticar atividades ilegais ou contrárias à boa-fé e à ordem pública.</li>
                <li>Respeitar legislações nacionais e internacionais aplicáveis.</li>
                <li>Não divulgar conteúdo racista, pornográfico ilegal, de apologia ao terrorismo ou contra os direitos humanos.</li>
                <li>Não danificar sistemas físicos ou lógicos do site, fornecedores ou terceiros.</li>
                <li>Respeitar direitos autorais e propriedade intelectual.</li>
              </ul>
              
              <h3 className="text-xl font-semibold text-gray-800 mb-4 mt-8" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Direitos do titular de dados
              </h3>
              
              <p className="mb-4">
                O titular de dados pessoais pode solicitar informações sobre seus dados coletados, solicitar anonimização, bloqueio ou eliminação de dados desnecessários ou excessivos, e ser informado sobre o compartilhamento de seus dados.
              </p>
              
              <p className="mb-4">
                Para exercer seus direitos, entre em contato pelo e-mail: comercial@precnacional.com.br. Pedidos serão respondidos conforme a legislação vigente, geralmente em até 72 horas, salvo exigência legal.
              </p>
              
              <h2 className="text-2xl font-semibold text-gray-800 mb-4 mt-8" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Termos de Uso – PrecNacional
              </h2>
              
              <p className="mb-2">O acesso e utilização do site PrecNacional estão sujeitos aos seguintes termos:</p>
              <ul className="list-disc pl-6 mb-6 space-y-2">
                <li>O usuário declara que utilizará o site para fins lícitos, respeitando as leis vigentes.</li>
                <li>Não é permitido copiar, reproduzir ou distribuir conteúdos do site sem autorização expressa.</li>
                <li>Não nos responsabilizamos por danos decorrentes de mau uso das informações ou falhas externas de terceiros.</li>
                <li>Reservamo-nos o direito de alterar ou atualizar os termos de uso a qualquer momento, com validade imediata após publicação no site.</li>
              </ul>
              
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mt-8">
                <div className="flex items-center mb-3">
                  <i className="ri-information-line text-blue-600 text-xl mr-3"></i>
                  <h4 className="text-lg font-semibold text-blue-800" style={{ fontFamily: 'Poppins, sans-serif' }}>
                    Contato
                  </h4>
                </div>
                <p className="text-blue-700">
                  Para dúvidas sobre nossa política de privacidade ou termos de uso, entre em contato pelo e-mail: 
                  <a href="mailto:comercial@precnacional.com.br" className="font-semibold hover:underline ml-1">
                    comercial@precnacional.com.br
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
